import { useTelegramNotifications } from '../../hooks/useTelegramNotifications';
import { cn } from '../../lib/utils';
import { buttonVariants } from '../ui/button';

export function TelegramConnect() {
  const { data } = useTelegramNotifications();
  if (!data?.enabled) return null;

  if (data.linked) {
    return (
      <div className="border border-line-soft p-4 text-left">
        <p className="text-[14px] font-semibold text-ink">✓ Telegram підключено</p>
        <p className="mt-1 text-[13px] text-muted">
          Статуси замовлень надходитимуть у бот. Щоб вимкнути — надішліть йому /stop.
        </p>
      </div>
    );
  }

  return (
    <a
      href={data.linkUrl ?? undefined}
      target="_blank"
      rel="noreferrer"
      className={cn(buttonVariants({ variant: 'secondary', size: 'md' }), 'no-underline')}
    >
      ОТРИМУВАТИ СТАТУСИ В TELEGRAM
    </a>
  );
}
